export default __webpack_public_path__ + "static/media/03.7177d616.jpg";